export const REELS = [
  {
    id: "apex-roofing",
    name: "Marcus Holloway",
    company: "Apex Roofing Co.",
    role: "Founder & CEO",
    quote: "Tripled our leads in 4 months.",
    rating: 5,
    thumbnail:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&q=80&w=800&h=1400",
    video: null,
  },
  {
    id: "northbridge",
    name: "Priya Sharma",
    company: "Northbridge Clinic",
    role: "Director of Marketing",
    quote: "We rank #1 for every search that matters.",
    rating: 5,
    thumbnail:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=800&h=1400",
    video: null,
  },
  {
    id: "driftboard",
    name: "David Okafor",
    company: "Driftboard SaaS",
    role: "Co-Founder",
    quote: "Paid CAC dropped 38% from the new site.",
    rating: 5,
    thumbnail:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=800&h=1400",
    video: null,
  },
  {
    id: "maison",
    name: "Elena Russo",
    company: "Maison Hospitality",
    role: "Brand Director",
    quote: "Site converts at 4.2%, up from 0.9%.",
    rating: 5,
    thumbnail:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=800&h=1400",
    video: null,
  },
  {
    id: "ironcore",
    name: "Jordan Reyes",
    company: "Ironcore Build Co.",
    role: "Operations Lead",
    quote: "Calls up 240%, closing 2× more deals.",
    rating: 5,
    thumbnail:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=800&h=1400",
    video: null,
  },
];
